import endpoints from "../../functions/databaseEndpoints";
export async function getPeriodsFromDB() {
   const url = `${endpoints.PUBLIC_ENDPOINT}getPeriods`;
   try {
      const res = await fetch(url);
      const json = await res.json();
      if (res.ok) {
         return json;
      } else {
         throw new Error(json);
      }
   } catch (error) {
      console.log(error.message);
   }
}

export async function getCountriesFromDB() {
   const url = `${endpoints.PUBLIC_ENDPOINT}getCountries`;
   try {
      const res = await fetch(url);
      const json = await res.json();
      if (res.ok) {
         return json;
      } else {
         throw new Error(json);
      }
   } catch (error) {
      console.log(error.message);
   }
}
